var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("Loader", { attrs: { loading: _vm.loading, size: 45 } })
    : _c("div", [
        _c("div", { staticClass: "input-container" }, [
          _c(
            "label",
            { staticClass: "custom-file-upload", attrs: { for: "imageInput" } },
            [
              _vm._v(
                _vm._s(!_vm.selectedImage ? "Select image" : "Change image")
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { id: "imageInput", type: "file", accept: "image/*" },
            on: { change: _vm.handleImageUpload }
          })
        ]),
        _vm._v(" "),
        _vm.selectedImage
          ? _c("div", { staticClass: "original-image" }, [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  ref: "image",
                  attrs: { src: _vm.selectedImage, alt: "Original Image" },
                  on: { load: _vm.initializeCropper }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-container" }, [
                _c(
                  "button",
                  { staticClass: "btn-save", on: { click: _vm.saveImage } },
                  [_vm._v("Save")]
                )
              ])
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d3ffabc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d3ffabc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/CropperImage.vue
// module id = 792
// module chunks = 0